import baseRoute from '../baseRoute';

export default `${baseRoute}/account` as const;
